import publicApiClient from '../clients/publicApiClient';
import { API_ENDPOINTS } from '../endpoints';

export const configApi = {
  get() {
    return publicApiClient.get(API_ENDPOINTS.config.get, {
      credentials: 'omit',
    });
  },
};
